import BaseSubGridPanel from "../../Base/BaseSubGridPanel";

const keyName = `RoutePreTrackSub`;

export default class RoutePreTrackSub extends BaseSubGridPanel {

    constructor(props) {
        super(props);
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        const context = this;
        context.gridName = 'RoutePreTrackGrid';
        context.subElementName = 'RoutePreTrackPage';
        context.tableName = 'route_pretrack';
        context.idName = 'route_id';
        context.topMenuButtonNames = ['edit'];
    }

    setDialogTitle(context) {
        context.dialog.cmp.setTitle(`Предварительный трек ${context.grid.getCurrentRow()[`route_name`]}`);
    }
}

